import { useState } from "react";
import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

const FLOWS = {
  sell: [
    ["Snap it", "Take a few photos and add the essentials. Your listing goes live with an urgent tag."],
    ["Set your deadline", "Tell buyers how soon you need it gone so only serious people reach out."],
    ["Close the deal", "Agree on a price, meet or arrange handover, and move on with your day."],
  ],
  buy: [
    ["Browse urgent deals", "See items from sellers who need to move them now, sorted by deadline."],
    ["Make an offer", "Message the seller directly and lock in a price before someone else does."],
    ["Pick it up", "Arrange handover with the seller and enjoy the find."],
  ],
};

export const HowItWorks = () => {
  const [mode, setMode] = useState("sell");
  return (
    <section id="how" className="mx-auto max-w-7xl px-5 sm:px-8 py-24 lg:py-36" data-testid="how-section">
      <div className="grid lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-5">
          <Eyebrow>How it works</Eyebrow>
          <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
            Three steps.<br />Zero waiting around.
          </h2>
          <div className="mt-10 inline-flex rounded-full border border-white/15 p-1" role="tablist">
            {["sell", "buy"].map((m) => (
              <button key={m} onClick={() => setMode(m)} data-testid={`how-toggle-${m}`} role="tab" aria-selected={mode === m}
                className="relative px-6 py-2.5 text-sm font-semibold capitalize">
                {mode === m && <motion.span layoutId="how-pill" className="absolute inset-0 rounded-full bg-[#FF3838]" transition={{ type: "spring", stiffness: 300, damping: 30 }} />}
                <span className={`relative transition-colors ${mode === m ? "text-[#0A0B0E]" : "text-zinc-300"}`}>I want to {m}</span>
              </button>
            ))}
          </div>
        </Reveal>
        <div className="lg:col-span-7 lg:pt-6">
          {FLOWS[mode].map(([t, d], i) => (
            <motion.div key={mode + i} initial={{ opacity: 0, x: 24 }} animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group grid grid-cols-[auto_1fr] gap-6 sm:gap-10 border-t border-white/10 py-8 last:border-b" data-testid={`how-step-${i + 1}`}>
              <span className="font-mono text-sm text-[#FF3838] pt-2">0{i + 1}</span>
              <div>
                <h3 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight transition-transform duration-500 group-hover:translate-x-2">{t}</h3>
                <p className="mt-3 max-w-md text-zinc-400 leading-relaxed">{d}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
